import React, { useState, useEffect } from "react";
import BankAccountService from "../../../../../ops/modules/patients/modules/new-bridge/services/BankAccountService";
import EventService from "../../../../../../service/event/EventService";
import { CircularProgress } from "react-md";
import CloseIcon from "@material-ui/icons/Close";
import { Radio, IconButton } from "@material-ui/core";
import { errorMessageHandler } from "../../../disqualification-module/utils/helperMethod";
import NavigoAPIServices from "../../services/navigoAPIServices";
import { Button } from "react-md";
import AddBankAccount from "./add-bank-account";

const ChangeAccountForClaimMiddleware = ({
  menuFor,
  setOpenChangeBankAccountMiddlewareDialog,
  setIsBankAccountSuccessScreen,
  isBankAccountSuccessScreen,
  setBankAccountSuccessScreenHeading,
  setOpenBankAccountVerificationDialog,
  fetchMaskedBankAccountForPatient,
  getAllClaims,
}) => {
  const [fetchPrimarybankAccountResponse, setFetchPrimarybankAccountResponse] =
    useState(null);
  const [isChangeAccountScreen, setIsChangeAccountScreen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [
    selectedBankAccountToBeUpdatedForClaim,
    setSelectedBankAccountToBeUpdatedForClaim,
  ] = useState(null);
  const bankAccountService = new BankAccountService();
  const navigoAPIServices = new NavigoAPIServices();

  const BANK_ACCOUNT_VERIFICATION_STATUS_VERIFIED = 1;
  const BANK_ACCOUNT_VERIFICATION_STATUS_UNVERIFIED = 0;
  const BANK_ACCOUNT_VERIFICATION_STATUS_REJECTED = 2;

  const isPrimaryBankAccountNotRejected = (bankAcc) => {
    return (
      bankAcc?.verificationStatus != BANK_ACCOUNT_VERIFICATION_STATUS_REJECTED
    );
  };

  const handleCloseModal = () => {};

  const getVerificationStatusColor = (verificationStatus) => {
    const colorMap = {
      0: "#FFBD2D",
      1: "#1BC47D",
      2: "#E44437",
    };
    return colorMap[verificationStatus ?? -1];
  };
  const getVerificationStatusLabel = (verificationStatus) => {
    const labelMap = {
      0: "Unverified",
      1: "Verified",
      2: "Rejected",
    };
    return labelMap[verificationStatus ?? -1];
  };

  const handleUpdateBankAccountForClaim = (claimId, accId) => {
    setLoading(true);

    navigoAPIServices.updateClaim(
      claimId,
      {
        bankAccountIdUpdate: accId,
      },
      (response) => {
        console.log("Bank account updated successfully for this claim");
        EventService.emit("showError", {
          message: "Bank account updated successfully for this claim",
        });
        setLoading(false);
        if (setIsBankAccountSuccessScreen) {
          setIsBankAccountSuccessScreen(true);
        }
        if (setBankAccountSuccessScreenHeading) {
          setBankAccountSuccessScreenHeading(
            "Bank account updated successfully for this claim"
          );
        }
        if (getAllClaims) {
          getAllClaims();
        }
        if (fetchMaskedBankAccountForPatient) {
          fetchMaskedBankAccountForPatient(
            menuFor?.patientId,
            response?.bankAccountId
          );
        }
        handleCloseModal();
        if (setOpenChangeBankAccountMiddlewareDialog) {
          setOpenChangeBankAccountMiddlewareDialog(false);
        }
      },
      (error) => {
        console.error("Error updating claim:", error);
        EventService.emit("showError", {
          message:
            "Error updating bank account for this claim : " +
            errorMessageHandler(error).toString(),
        });
        setLoading(false);
      }
    );
  };

  const fetchMaskedPrimaryBankAccountForPatient = (pid) => {
    setLoading(true);
    bankAccountService.fetchMaskedPrimaryBankAccountForPatient(
      pid,
      (res) => {
        setFetchPrimarybankAccountResponse(res);
        setLoading(false);
      },
      (err) => {
        EventService.emit("showError", {
          message:
            "Error fetching current bank account for the patient : " +
            errorMessageHandler(err).toString(),
        });
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (menuFor?.patientId) {
      fetchMaskedPrimaryBankAccountForPatient(menuFor?.patientId);
    }
  }, [menuFor]);

  const isPrimaryAccSameAsCurrentAccOnClaim = (
    fetchPrimarybankAccountResponse
  ) => {
    return (
      (fetchPrimarybankAccountResponse?.id ?? "XYZ") ===
      (menuFor?.bankAccountId ?? "ABC")
    );
  };

  const getMaskedBankAccountNum = (last4, accNumLength) => {
    return "X".repeat(Math.abs(accNumLength - 4)) + (last4 ?? "").toString();
  };

  return (
    <>
      {loading ? (
        <CircularProgress />
      ) : Boolean(isChangeAccountScreen) ? (
        <AddBankAccount
          handleCloseModal={() => {
            setIsChangeAccountScreen(false);
            setOpenChangeBankAccountMiddlewareDialog(true);
          }}
          setOpenChangeBankAccountMiddlewareDialog={
            setOpenChangeBankAccountMiddlewareDialog
          }
          onSuccessfullSaveCallback={() => {
            fetchMaskedPrimaryBankAccountForPatient(menuFor?.patientId);
            setIsChangeAccountScreen(false);
            setOpenChangeBankAccountMiddlewareDialog(true);
            // setOpenChangeBankAccountMiddlewareDialog(false);
          }}
          operation={"update"}
          menuFor={menuFor}
        />
      ) : Boolean(
          isPrimaryBankAccountNotRejected(fetchPrimarybankAccountResponse) &&
            !isPrimaryAccSameAsCurrentAccOnClaim(
              fetchPrimarybankAccountResponse
            )
        ) ? (
        <div
          style={{
            width: "600px",
            left: "20%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="custom-modal-content scrollable-modal-full-height"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "100%",
                fontSize: "24px",
                fontWeight: 700,
                fontFamily: "Montserrat",
                textAlign: "center",
              }}
            >
              Choose bank account
            </div>

            <IconButton
              onClick={() => {
                handleCloseModal();
                setOpenBankAccountVerificationDialog(true);
                setOpenChangeBankAccountMiddlewareDialog(false);
              }}
            >
              <CloseIcon fontSize="large" />
            </IconButton>
          </div>
          <div style={{ height: "32px" }}></div>
          <div
            style={{
              fontSize: 12,
              overflow: "hidden",
              border: "1px solid #CED4DA",
              borderRadius: "4px",
              paddingTop: "16px",
              paddingLeft: "16px",
              paddingRight: "16px",
              paddingBottom: "16px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              width: "500px",
            }}
          >
            <div style={{ fontSize: 14 }}>Verification status</div>
            <div
              style={{
                backgroundColor:
                  getVerificationStatusColor(
                    fetchPrimarybankAccountResponse?.verificationStatus
                  ) ?? "",
              }}
              onClick={() => {}}
            >
              <div
                style={{
                  color: "white",
                  paddingTop: "4px",
                  paddingBottom: "4px",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  border: "1px solid white",
                  borderRadius: "4px",
                  fontWeight: 700,
                }}
              >
                {getVerificationStatusLabel(
                  fetchPrimarybankAccountResponse?.verificationStatus
                ) ?? ""}
              </div>
            </div>
          </div>
          <div style={{ height: "16px" }}></div>
          <div
            style={{
              fontSize: 12,
              overflow: "hidden",
              border: "1px solid #CED4DA",
              borderRadius: "4px",
              paddingTop: "16px",
              paddingLeft: "16px",
              paddingRight: "16px",
              paddingBottom: "16px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              width: "500px",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div>
                {fetchPrimarybankAccountResponse?.branchInfo?.bankName ?? ""}
              </div>
              <div style={{ height: "16px" }}></div>
              <div>
                {getMaskedBankAccountNum(
                  fetchPrimarybankAccountResponse?.last4,
                  fetchPrimarybankAccountResponse?.accNumLength
                ) ?? ""}
              </div>
            </div>
            <Radio
              checked={
                (selectedBankAccountToBeUpdatedForClaim?.id ?? "XYZ") ===
                fetchPrimarybankAccountResponse?.id
              }
              value={fetchPrimarybankAccountResponse}
              onChange={(e) => {
                setSelectedBankAccountToBeUpdatedForClaim(
                  fetchPrimarybankAccountResponse
                );
              }}
            />
          </div>

          <div style={{ height: "40px" }}></div>

          <div
            style={{ color: "orange", fontWeight: 700, cursor: "pointer" }}
            onClick={(e) => setIsChangeAccountScreen(true)}
          >
            Change bank account
          </div>

          <Button
            fullWidth
            variant="contained"
            onClick={(e) => {
              handleUpdateBankAccountForClaim(
                menuFor?.id,
                selectedBankAccountToBeUpdatedForClaim?.id
              );
            }}
            className="full-width-button"
            disabled={
              loading || !Boolean(selectedBankAccountToBeUpdatedForClaim?.id)
            }
            style={{
              backgroundColor:
                loading || !Boolean(selectedBankAccountToBeUpdatedForClaim?.id)
                  ? "#e0e0e0"
                  : "#f57c00",
              color: "#fff",
              marginTop: "20px",
            }}
          >
            Done
          </Button>
        </div>
      ) : (
        <AddBankAccount
          handleCloseModal={() => {
            setOpenChangeBankAccountMiddlewareDialog(false);
            setOpenBankAccountVerificationDialog(true);
          }}
          setOpenChangeBankAccountMiddlewareDialog={
            setOpenChangeBankAccountMiddlewareDialog
          }
          onSuccessfullSaveCallback={() => {
            fetchMaskedPrimaryBankAccountForPatient(menuFor?.patientId);
            // setOpenChangeBankAccountMiddlewareDialog(false);
          }}
          operation={"update"}
          menuFor={menuFor}
        />
      )}
    </>
  );
};

export default ChangeAccountForClaimMiddleware;
